import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { CustomsValidators } from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PickupListService {
  url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.bffBaseUrl}/pages/pickup-list`;
  }

  getAllSites() {
    const urlBuilder = this.url;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
